import React from 'react';

import BauxAll from '../../components/Monitoring/BauxAll';

function BauxAllView() {
  return (
    <BauxAll />
  );
}

export default BauxAllView;
